export default __webpack_public_path__ + "images/ceb2e360f4a61fb75eb24dbb798f6f31-compact_theme.png";